import { ReactionCodeValue as ReactionCode } from '../../../../reactions/constants';
export const getReactionsState = (comment, reactionsStateIN) => {
    var _a, _b, _c;
    const total = ((_a = comment.reactions) === null || _a === void 0 ? void 0 : _a.total) || 0;
    const reactions = normalizeReactions((_b = comment.reactions) === null || _b === void 0 ? void 0 : _b.reactions);
    if (reactionsStateIN.type === 'IDLE') {
        return {
            pending: false,
            total,
            reactions,
            activeReaction: (_c = reactions.find((r) => r.hasReacted)) === null || _c === void 0 ? void 0 : _c.reactionCode,
        };
    }
    return {
        pending: true,
        total,
        reactions,
        activeReaction: reactionsStateIN.reactionCode,
    };
};
const normalizeReactions = (reactions) => {
    return Object.values(ReactionCode).map((code) => {
        const reaction = reactions === null || reactions === void 0 ? void 0 : reactions.find((r) => r.reactionCode === code);
        return {
            reactionCode: code,
            hasReacted: (reaction === null || reaction === void 0 ? void 0 : reaction.hasReacted) || false,
            total: (reaction === null || reaction === void 0 ? void 0 : reaction.total) || 0,
            identities: (reaction === null || reaction === void 0 ? void 0 : reaction.identities) || [],
        };
    });
};
//# sourceMappingURL=comments-reaction-selectors.js.map